import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Literature.scss';
const LiteratureThumbReactView = ({ width, height, deviation })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(MinimalDumbo, {
        width: width,
        height: height,
        deviation: deviation
    }));
LiteratureThumbReactView.displayName = 'LiteratureThumbReactView';
export default LiteratureThumbReactView;
